import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Get_Api } from "../Api_Url";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ContentLoader from "react-content-loader";
import { Helmet } from "react-helmet-async";

function Cities() {
  const navigate = useNavigate();
  const { Country } = useParams();
  const location = useLocation();
  const id = location.state?.id;
  const [cities, setCities] = useState([]);
  const [country, setCountry] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCities = async () => {
    try {
      setLoading(true);
      // const response = await Get_Api(`api/city/byCountryId/${id}`);
      const response = await Get_Api(`api/city/GetCitiesByCountryName/${Country}`);
      setCities(response?.data);
      if (response?.data.length > 0) {
        setCountry(response.data[0].country);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setLoading(false);
    }
  };

  const [IsUploading, setIsUploading] = useState(false);
  const [CountryData, setCountryData] = useState({});

  const GetACountrydata = async () => {
    try {
      setIsUploading(true)
      const response = await Get_Api(`api/admin/GetACountry/${id}`)
      setCountryData(response?.data)
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      console.log(error)
    }
  }


  useEffect(() => {
    fetchCities();
    GetACountrydata();
  }, [Country]);

  const cityDetails = (name, cityId) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/citydetail/${name}`, { state: { id: cityId } });
  };

  return (
    <>
      <Helmet>
        <title>{CountryData?.MetaTitle || "Destination Details"}</title>
        <meta
          name="description"
          content={
            CountryData?.MetaDescription || "Explore destination details"
          }
        />
        {CountryData?.MetaTags?.map((tag, index) => (
          <meta key={index} name="keywords" content={tag} />
        ))}
      </Helmet>
      <Navbar />
      <div className="about-div">
        <h1>DESTINATION</h1>
        <p>
          <i>{country?.Name} - Destination</i>
        </p>
      </div>
      {
        country?.Heading && country?.Details && country?.extraImage &&

        <div className="vietnam-tours-container">
          <div className="vietnam-tours-text-content">
            <h1>{country?.Heading}</h1>
            <p>
              {country?.Details}
            </p>
            <div className="vietnam-tours-stats">
              <div>
                <h2>{country?.HeritageSites}</h2>
                <p>World Heritage Sites</p>
              </div>
              <div>
                <h2>{country?.EthnicMinorities}</h2>
                <p>Ethnic Minorities</p>
              </div>
              <div>
                <h2>{country?.Cities}</h2>
                <p>Cities</p>
              </div>
            </div>
          </div>
          <div className="vietnam-tours-map-container">
            <img
              src={country?.extraImage}
              alt="Vietnam Map"
              className="vietnam-tours-map"
            />
          </div>
        </div>
      }
      <div className="havequestion">
        <p>Whether you’re looking for places for a vacation. We are here to</p>
        <h1>Explore Cities</h1>
      </div>
      {/* <div className="Destination-div">
        {loading ? (
          <ContentLoader viewBox="0 0 820 450" height={"100%"} width={"100%"}>
            <rect x="10" y="10" rx="5" ry="5" width="260" height="140" />
            <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
            <rect x="550" y="10" rx="5" ry="5" width="260" height="140" />
            <rect x="10" y="160" rx="5" ry="5" width="260" height="280" />
            <rect x="280" y="300" rx="5" ry="5" width="260" height="140" />
            <rect x="550" y="160" rx="5" ry="5" width="260" height="280" />
          </ContentLoader>
        ) : (
          cities.map((city) => (
            <div key={city._id} className="Destination-card" style={{ backgroundImage: `url(${city.photos[0]})` }}>
              <div className="city-info">
                <h3>{city.name}</h3>
                <p>{city.description}</p>
                <div className="city-meta">
                </div>
                <button onClick={() => cityDetails(city.name, city._id)}>
                  View Details
                </button>
              </div>
            </div>
          ))
        )}
      </div> */}
      <div className='pd-copy1'>
        <div className="destination-container">
          {loading ? (
            <ContentLoader viewBox="0 0 820 450" height={"100%"} width={"100%"}>
              <rect x="10" y="10" rx="5" ry="5" width="260" height="140" />
              <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
              <rect x="550" y="10" rx="5" ry="5" width="260" height="140" />
              <rect x="10" y="160" rx="5" ry="5" width="260" height="280" />
              <rect x="280" y="300" rx="5" ry="5" width="260" height="140" />
              <rect x="550" y="160" rx="5" ry="5" width="260" height="280" />
            </ContentLoader>
          ) : (
            cities.map((city) => (
              <div
                key={city?._id}
                className="destination-card"
                style={{ backgroundImage: `url(${city?.photos[0]})` }}
                onClick={() => cityDetails(city?.name, city?._id)}
              >
                <div className="city-info">
                  <h3>{city?.name}</h3>
                  <p>{city?.description?.slice(0, 30)}</p>
                  <button onClick={() => cityDetails(city?.name, city?._id)}>
                    View Details
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Cities;
